import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {Paper} from "@mui/material";
import Api, {APIs} from "../../../Api";
import useQuery from "../../base/utils/UseQuery";
import ProjectPDF from "../components/ProjectPDF";
import {useDispatch, useSelector} from "react-redux";
import SMSDialog from "../../base/components/SMSDialog";
import ProjectTimeline from "../components/dark_version/ProjectDetails/ProjectTimeline";
import ProjectTeam, {ITeam} from "../components/dark_version/ProjectDetails/ProjectTeam";
import {snackbarActions} from "../../base/models/SnackbarSlice";
import {projectInfoActions} from "../../../store/features/ProjectInfoSlice";
import ProjectBasicInfoPDF, {
    TitleStyleTypography
} from "../components/dark_version/ProjectDetails/pdf/ProjectBasicInfoPDF";
import FinancialSummary from "../components/dark_version/ProjectDetails/pdf/FinancialSummary";
import ProjectProgressBar from "../components/dark_version/ProjectDetails/pdf/ProjectProgressBar";
import ProjectProgress from "../components/dark_version/ProjectDetails/pdf/ProjectProgress";


const smsDialogRef = React.createRef<SMSDialog>();

interface IProps {
    pid?: string
}

export default function ProjectInfoContainer(props: IProps) {
    const contentDivHeight = useSelector((state: any) => state.base.contentDivHeight);
    const [contentHeight, setContentHeight] = React.useState<number>(contentDivHeight);
    const ref = React.useRef<any>();
    const dispatch = useDispatch();
    React.useLayoutEffect(() => {
        if (ref.current && ref.current.clientHeight) {
            const headerHeight = ref.current.clientHeight;
            setContentHeight(contentDivHeight - headerHeight)
        }
    });
    let query = useQuery();
    let id = props.pid ?? query.get('id') ?? "-1";
    const [pid, setPID] = React.useState<string>(id)

    const [teams, setTeams] = React.useState<ITeam[]>([])


    React.useEffect(() => {
        id = props.pid ?? query.get('id') ?? "-1";
        setPID(id)
        dispatch(projectInfoActions.setPid(props.pid))
    }, [])
    React.useEffect(() => {
        Api.get(APIs.MoPD_PROJECT_SUMMARY, {pid: props.pid}).then((payload) => {
            if (payload) {
                dispatch(projectInfoActions.setBasicInfo(payload))
            }
        });

        Api.get(APIs.MoPD_PROJECT_TEAM, {pid: pid}).then((payload) => {
            if (payload) {
                setTeams(payload)
                dispatch(projectInfoActions.setTeams(payload))
            }
        });

        Api.get(APIs.MoPD_PROJECT_TIMELINE, {pid: props.pid}).then((payload: any) => {
            if (payload) {
                dispatch(projectInfoActions.setProjectComponents(payload))
            }
        });

        Api.get(APIs.MoPD_PROJECT_PHYSICAL, {pid: props.pid}).then((payload) => {
            if (payload) {
                dispatch(projectInfoActions.setPhysicalStatus(payload))
            }
        });
        Api.get(APIs.MoPD_PROJECT_FINANCIAL, {pid: props.pid}).then((payload) => {
            if (payload) {
                // setStatus(payload)
                // console.log("financial", payload)
                dispatch(projectInfoActions.setFinancialStatus(payload))
            }
        })

    }, [pid, dispatch]);


    const handleDownloadPC1 = async () => {
        dispatch(snackbarActions.showSnackbar({"msg": "Preparing to Download PC1"}));

        try {
            const url = Api.getURL(APIs.MoPD_PC1, {pid: pid});

            // Use fetch with AbortController to check if the URL is valid
            const controller = new AbortController();
            const signal = controller.signal;

            const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 seconds timeout

            const response = await fetch(url, {method: 'GET', signal});

            clearTimeout(timeoutId);

            if (response.ok) {
                // If response is ok, create a temporary link element and click it to start the download
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `PC-1-${pid}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                // Handle non-ok responses, like 404
                dispatch(snackbarActions.showSnackbar({"msg": "Error: File not found"}));
            }
        } catch (error: any) {
            if (error.name === 'AbortError') {
                // Handle fetch timeout
                dispatch(snackbarActions.showSnackbar({"msg": "Error: Request timed out"}));
            } else {
                // Handle other fetch errors
                dispatch(snackbarActions.showSnackbar({"msg": `Error: ${error.message}`}));
            }
        }
    };

    const financialProgress = useSelector((state: any) => state.projectInfo.financialProgress) || 0


    return (
        <Box sx={{
            display: 'flex', flexDirection: 'row', height: {contentHeight},
            justifyContent: 'space-between', width: "100%"
        }}>
            <Box sx={{flex: 1, m: 0, p: 0}}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: "flex-end",
                    paddingBottom: 0,
                    height: "10%"
                }}>
                    <Button color={"success"} variant={"contained"}
                            onClick={() => {
                                smsDialogRef.current?.show();
                            }}
                    >
                        Send SMS
                    </Button>
                    &nbsp;&nbsp;
                    <Button style={{width: "150px"}} color="secondary" variant="contained"
                            onClick={handleDownloadPC1}>
                        Download PC-1
                    </Button>

                    &nbsp;&nbsp;
                    <ProjectPDF pid={pid}/>
                </Box>

                <Paper elevation={6} sx={{overflow: "auto", width: "100%", height: "90%", p: 0, m: 0}}>

                    <div style={{display: "block", padding: 10}}>
                        <ProjectBasicInfoPDF/>
                    </div>
                    <div style={{display: "block", padding: 10}}>
                        <TitleStyleTypography>Financial Summary (US$ Million)</TitleStyleTypography>
                        <FinancialSummary/>
                    </div>
                    <div style={{display: "block", padding: 10}}>
                        <TitleStyleTypography>Project Timeline</TitleStyleTypography>
                        <ProjectTimeline/>
                    </div>
                    <div style={{display: "block", padding: 10}}>
                        <TitleStyleTypography>Financial Progress</TitleStyleTypography>
                        <ProjectProgressBar progress={financialProgress}/>

                    </div>
                    <div style={{display: "block", padding: 10}}>
                        <TitleStyleTypography>Project Progress</TitleStyleTypography>
                        {/*<PhysicalStatus/>*/}
                        <ProjectProgress/>
                    </div>
                    <div style={{display: "block", padding: 10}}>
                        <TitleStyleTypography>Project Focal Person</TitleStyleTypography>
                        <ProjectTeam teams={teams}/>
                    </div>


                </Paper>
            </Box>
            <SMSDialog teams={teams} pid={pid} ref={smsDialogRef}/>
        </Box>
    );
}
